import * as React from "react"
import { ThemeCss, Heading } from "gatsby-interface"
import { NarrowSingleColumn } from "@modules/ui/layouts/Containers"

const baseCss: ThemeCss = theme => ({
  textAlign: `center`,
  fontSize: theme.fontSizes[6],
  fontWeight: 800,
  letterSpacing: `-0.02em`,
  lineHeight: theme.lineHeights.solid,
  margin: 0,

  [theme.mediaQueries.desktop]: {
    fontSize: theme.fontSizes[8],
  },
})

export type WizardHeaderProps = {
  children: React.ReactNode
}

export function WizardHeader({ children }: WizardHeaderProps) {
  return (
    <NarrowSingleColumn>
      <Heading as="h1" css={baseCss} variant="EMPHASIZED">
        {children}
      </Heading>
    </NarrowSingleColumn>
  )
}
